/*
  CEBE theme — assets/cebe.js, part 3 of 4: gift note.
  Load all parts in this order, each with defer: cebe-part-1.js, cebe-part-2.js, cebe-part-3.js, cebe-part-4.js.
  Made by website/review/sammel-2026-10-03/werkzeuge/zusammenfuehren.py from assets/cebe.js (MD5 46a65575485db7a4e2796e006f51aee3);
  every Shopify upload file must stay below 26 000 bytes. Between the markers stands the original code; the only change:
  a name that one part changes and another reads, or that comes from a later part, reads cebeShared.<name> (one private
  object, window.__cebeParts.main). See website/review/sammel-2026-10-03/TEILUNG.md.
*/
(function () {
  'use strict';

  var cebeShared = (window.__cebeParts = window.__cebeParts || {}).main || (window.__cebeParts.main = {});
  if (cebeShared.done !== 2) return; // part 2 did not finish (error or early return): stop, as the single file would
  var config = cebeShared.config;
  var $ = cebeShared.$;
  var $$ = cebeShared.$$;
  var announce = cebeShared.announce;
  var readJson = cebeShared.readJson;
  var fill = cebeShared.fill;
  var showError = cebeShared.showError;
  var updateEdges = cebeShared.updateEdges;
  var updateFit = cebeShared.updateFit;
  var cartIdle = cebeShared.cartIdle;
  var exclusive = cebeShared.exclusive;

  /* ---- assets/cebe.js, lines 771–1028 ---- */

  /* ---------- Gift option (snippets/cebe-gift-note.liquid, M-56 (7), M-58) ----------
     The box is the cart attribute Gift, the message the cart note (it becomes the order note on the packing slip).
     Saved through /cart/update.js in the same queue as the quantities, so "Check out" waits for an open save; the
     fields also go with the cart form once this page has changed them. The drawer and the cart page may both hold a
     copy: kept equal.
     Never two gift saves at once (R716-1): Shopify carries out simultaneous cart requests without a promised order,
     so a newer save sent beside an open one could be applied first and then be overwritten by the older one. */
  var giftTimer = 0;
  var giftLiveTimer = 0;
  var giftQueued = false;
  var giftSource = null;
  var giftSent = '';
  var giftOpen = null; // the one gift save on its way (a promise that never rejects); null when there is none
  var giftPosts = 0; // gift saves sent from this page
  var giftShown = 0; // giftPosts when the page came back from the back-forward cache; -1 if a save was on its way then
  var giftTouched = false; // box or message changed on this page since it was drawn or took the server's state

  function giftBlocks() {
    return $$('[data-cebe-gift]');
  }

  function giftBlock() {
    return giftSource && document.contains(giftSource) ? giftSource : giftBlocks()[0];
  }

  // What the form would send: each empty hidden field first, the ticked box or the enabled message wins.
  // rendered = true: the message counts while disabled too, i.e. what the server held when the block was drawn.
  function giftPayload(block, rendered) {
    var body = {};
    $$('[name]', block).forEach(function (field) {
      if ((field.disabled && !rendered) || (field.type === 'checkbox' && !field.checked)) return;
      var match = /^attributes\[(.+)\]$/.exec(field.name);
      if (match) (body.attributes = body.attributes || {})[match[1]] = field.value;
      else if (field.name === 'note') body.note = field.value;
    });
    return JSON.stringify(body);
  }

  // Copy box and message from one block to the others; a hidden message is disabled, so it is never sent.
  function giftSync(from) {
    var box = $('[data-cebe-gift-toggle]', from);
    var text = $('[data-cebe-gift-text]', from);
    giftBlocks().forEach(function (block) {
      var otherBox = $('[data-cebe-gift-toggle]', block);
      var otherText = $('[data-cebe-gift-text]', block);
      if (!otherBox || !otherText) return;
      if (block !== from && box && text) {
        otherBox.checked = box.checked;
        if (otherText.value !== text.value) otherText.value = text.value;
      }
      otherText.disabled = !otherBox.checked;
      var count = $('[data-cebe-gift-count]', block);
      if (count) count.textContent = otherText.value.length + '/' + otherText.maxLength;
    });
  }

  // The visible count changes at once; screen readers hear it once typing pauses.
  function giftSpeak() {
    window.clearTimeout(giftLiveTimer);
    giftLiveTimer = window.setTimeout(function () {
      giftBlocks().forEach(function (block) {
        var text = $('[data-cebe-gift-text]', block);
        var live = $('[data-cebe-gift-live]', block);
        if (text && live && block.dataset.count) live.textContent = fill(block.dataset.count, '[used]', String(text.value.length));
      });
    }, 1000);
  }

  function giftError(message) {
    giftBlocks().forEach(function (block) {
      showError($('[data-cebe-gift-error]', block), message);
    });
    if (message) announce(message);
    if (cebeShared.drawer && cebeShared.drawer.open) {
      updateFit();
      updateEdges();
    }
  }

  // The only way a gift save goes out; the callers send only while no other one is on its way (giftOpen).
  // Every save goes with keepalive: if the page goes away meanwhile, the browser still delivers it.
  // A save that hangs is stopped after 7 s while the page lives: it holds the cart queue, and with it "Check out"
  // and the quantities. The promise never rejects; giftSent is what the server holds as far as known.
  function giftPost(body) {
    giftPosts += 1;
    var controller = window.AbortController ? new AbortController() : null;
    var timer = controller
      ? window.setTimeout(function () {
          controller.abort();
        }, 7000)
      : 0;
    function settled() {
      window.clearTimeout(timer);
      if (giftOpen === open) giftOpen = null;
    }
    var open = fetch(config.routes.cartUpdate, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body,
      keepalive: true,
      signal: controller ? controller.signal : undefined
    })
      .then(readJson)
      .then(
        function () {
          giftSent = body;
          giftError('');
        },
        function () {
          // Unknown what the server holds now (the answer may be lost): the next change is sent in any case.
          giftSent = null;
          var block = giftBlock();
          giftError((block && block.dataset.error) || config.strings.error); // the cart form still sends the fields
        }
      )
      .then(settled, settled);
    giftOpen = open;
    return open;
  }

  // now = false: wait until typing pauses. Only one save waits in the queue; it sends the newest values when it runs.
  function giftSave(now) {
    window.clearTimeout(giftTimer);
    giftTimer = 0;
    if (!window.fetch || !config.routes.cartUpdate) return;
    if (!now) {
      giftTimer = window.setTimeout(function () {
        giftSave(true);
      }, 500);
      return;
    }
    if (giftQueued) return;
    giftQueued = true;
    exclusive(giftRun);
  }

  // The save in the queue. A save sent on leaving the page may still be on its way (the page lives on in the
  // back-forward cache): wait for it first. Then send the newest values, or nothing when the server holds them.
  function giftRun() {
    if (giftOpen) return giftOpen.then(giftRun);
    giftQueued = false;
    var block = giftBlock();
    var body = block ? giftPayload(block) : giftSent;
    if (body === giftSent) {
      giftError('');
      return Promise.resolve();
    }
    return giftPost(body);
  }

  // Back from the back-forward cache: box and message as the server holds them now (another tab may have changed
  // them), taken from the fresh drawer answer. Never while the message is being typed or a change waits. Never when
  // a gift save was on its way as the page came back, or one went out since (giftShown, set on pageshow): the answer
  // may have been read before that save was applied, and would put an older state back in the fields (R716-1, A1).
  function giftAdopt(fresh) {
    var source = fresh && $('[data-cebe-gift]', fresh);
    var block = giftBlock();
    if (!source || !block) return;
    var text = $('[data-cebe-gift-text]', block);
    if (giftShown !== giftPosts || giftTimer || giftQueued || (text && text === document.activeElement)) return;
    var box = $('[data-cebe-gift-toggle]', block);
    var freshBox = $('[data-cebe-gift-toggle]', source);
    var freshText = $('[data-cebe-gift-text]', source);
    if (box && freshBox) box.checked = freshBox.checked;
    if (text && freshText) text.value = freshText.value;
    giftSync(block);
    giftSent = giftPayload(block, true);
    giftTouched = false;
    giftError('');
  }

  // Before "Check out": a save that still waits for the typing pause goes now, so the queue holds the checkout.
  // So does a save from leaving or hiding the page that is still on its way outside the queue.
  function giftFlush() {
    if (giftTimer || (giftOpen && cartIdle())) giftSave(true);
  }

  function initGift() {
    var first = giftBlocks()[0];
    if (!first) return;
    giftSync(first);
    // What the server holds, a note without the box included (after the path without JavaScript): the next save,
    // which sends the visible state, then always goes out and clears that note.
    giftSent = giftPayload(first, true);

    document.addEventListener('change', function (event) {
      var box = event.target.closest('[data-cebe-gift-toggle]');
      var text = event.target.closest('[data-cebe-gift-text]');
      if (!box && !text) return;
      giftSource = event.target.closest('[data-cebe-gift]');
      giftTouched = true;
      giftSync(giftSource);
      if (box && cebeShared.drawer && cebeShared.drawer.open) {
        updateFit(); // the message takes room in the foot
        updateEdges();
      }
      giftSave(true); // the box at once, the message when the field is left
    });

    document.addEventListener('input', function (event) {
      if (!event.target.closest('[data-cebe-gift-text]')) return;
      giftSource = event.target.closest('[data-cebe-gift]');
      giftTouched = true;
      giftSync(giftSource);
      giftSpeak();
      giftSave(false);
    });

    // Enter on the box must not submit the cart form ("Update" on the cart page, "Check out" in the drawer).
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' && event.target.closest && event.target.closest('[data-cebe-gift-toggle]')) event.preventDefault();
    });

    // Leaving or hiding the page (R716-1): the last chance for what this page changed and has not saved yet. No gift
    // save on its way: the visible state (message and box) goes out now, even while quantities still wait in the
    // queue. One on its way: nothing more is sent, since a second save could overtake it and the older one would win;
    // typed text waits in the queue and follows the open save if the page lives on (back-forward cache), and if the
    // page is gone for good, the server keeps the open save. Nothing changed here: nothing is written (a note without
    // the box, left by the path without JavaScript, stays until a change or "Check out").
    function giftLeave() {
      var typing = giftTimer;
      window.clearTimeout(giftTimer);
      giftTimer = 0;
      if (!window.fetch || !config.routes.cartUpdate || !giftTouched) return;
      if (giftOpen) {
        if (typing) giftSave(true);
        return;
      }
      var block = giftBlock();
      var body = block && giftPayload(block);
      if (body && body !== giftSent) giftPost(body);
    }
    window.addEventListener('pagehide', giftLeave);
    // Hidden: another tab or app; on a phone often the last moment, as a page in the background may be closed
    // without pagehide.
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') giftLeave();
    });

    // Back from the back-forward cache: initCheckout reads the drawer again, and giftAdopt takes its gift state only
    // if no gift save was on its way now and none goes out before the answer.
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) giftShown = giftOpen ? -1 : giftPosts;
    });

    // A form sent from a page that has not changed box or message leaves both out (R716-1, A2): the cart keeps what
    // the server holds. This page may have been drawn before the last save of the page before arrived ("Back", or a
    // link followed at once); sending its older state would overwrite that save. The fields go as before when this
    // page changed them, when it does not know what the server holds (failed save), or when it shows something else
    // than it was drawn with (a note without the box, which "Check out" clears).
    document.addEventListener('formdata', function (event) {
      var block = event.target && event.target.querySelector ? $('[data-cebe-gift]', event.target) : null;
      if (!block || giftTouched || giftSent === null || giftPayload(block) !== giftSent) return;
      event.formData.delete('note');
      event.formData.delete('attributes[Gift]');
    });
  }
  /* ---- end of lines 771–1028 ---- */

  cebeShared.giftAdopt = giftAdopt;
  cebeShared.giftFlush = giftFlush;
  cebeShared.initGift = initGift;
  cebeShared.done = 3;
})();
